import './App.css';
import {useEffect} from "react";
import ScaleLoader from "react-spinners/ScaleLoader";


function App() {
  const loading = true;
  const color = "#ffffff";
  const myStore = 'https://my.popsical.com'
  const plan = 'https://app.popsical.com'
  const payment = 'https://app.popsical.com/payment/card'
  const redeem = 'https://app.popsical.com/redeem'
  const couponSG = 'https://coupon.popsical.com/'
  const couponMY = 'https://my.coupon.popsical.com/'
  const whatApps = 'https://wa.me/message/ZVEW5TUTBDPTP1?src=qr'
  // const coupon = 'https://my.popsical.com/pages/premium'

  useEffect(() => {
    // Keep crawled HTML dump under /html browsable
    if (window.location.pathname === '/html' || window.location.pathname === '/html/') {
      window.location.replace('/html/index.html');
      return;
    }
    if (window.location.pathname.startsWith('/html/')) {
      return;
    }
    if(window.location.pathname.includes('whatap')) {
      window.location.href = whatApps;
    }else if(window.location.pathname.includes('plans')) {
      window.location.href = plan;
    }else if(window.location.pathname.includes('premium')) {
        window.location.href = plan;
    }else if(window.location.pathname.includes('payment')){
      window.location.href = payment;
    } else if(window.location.pathname.includes('redeem')){
      window.location.href = redeem;
    }else if(window.location.pathname.includes('account')){
      var url = window.location.href;
      url = url.replace('app.popsical.com', 'web.popsical.com')
      window.location.href = url;
    }else if(window.location.pathname.includes('coupon')){
      try {
        const params = new URL(window.location.href).searchParams;
        const country = params.get('country') || 'sg';
        let url = couponSG;
        if (country?.includes('my')) {
          url = couponMY;
        }else{
          url = couponSG;
        }
        window.location.href = `${url}?country=${country}`
      }catch (e){
        console.log(e);
        window.location.href = couponSG;
      }
    }
    else {
      window.location.href = myStore;
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <ScaleLoader
          color={color}
          loading={loading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </header>
    </div>
  );
}

export default App;
